// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__vwjLe","wrapper":"PriceList_wrapper__L7-Rp","footerStyle":"PriceList_footerStyle__AUdEc"};